import React from 'react';
import { LinkButton, ListWrapper } from '@builtbypixel/nucleus';
import { Button } from '@chakra-ui/react';
import moment from 'moment';

import setup from './setup';

const List = () => {
  const columns = [
    {
      Header: 'Ref',
      accessor: 'id',
      id: 'edit',
      Cell: ({ row }) => (
        <LinkButton to={`${setup.model}/edit/${row.original.id}`}>
          <Button variant='link' variantColor='secondary' rounded='md'>
            {row.original.id}
          </Button>
        </LinkButton>
      ),
    },
    {
      Header: 'Full Name',
      accessor: 'full_name',
    },
    {
      Header: "Deal Name",
      accessor: "deal_name"
    },
    {
      Header: "Created",
      accessor: "created_at.date",
      Cell: props => moment(props.value).format("LLL")
    }
  ];

  return <ListWrapper setup={setup} columns={columns} />;
};

export default List;
